/**
 * How a document's workflow state should read on screen.
 *
 * An approval workflow carries two names per state: `Status` is the hash it keys transitions off
 * (`InTest`, `Pending_DLE`, `Approved`), and `StateName` is the name authored for people ("In Test",
 * "Waiting for District Lab Engineer Approval", "Authorized in Sitemanager"). The panels label this
 * field "Status" to the user, so the authored name is the one that belongs there.
 *
 * The fallback is not decoration. A Draft is created by the API service without consulting the
 * approval workflow, so it carries a `Status` and no `StateName` at all - on LADOTD that is 818 of a
 * 6,000-document sample. Preferring `StateName` without falling back would blank every one of them.
 *
 * @module DocumentStateDisplay
 */

/** @param {any} pValue @return {string} the value as trimmed display text, '' when there is none. */
const asDisplayText = (pValue) => (pValue === undefined || pValue === null) ? '' : String(pValue).trim();

/**
 * The workflow state of a document, as it should be shown to a person.
 *
 * @param {Record<string, any>} pRecord - a document-shaped record carrying `StateName` and/or `Status`.
 * @return {string} the authored state name, else the raw status, else '' (never 'undefined').
 */
function resolveDocumentStateDisplay(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object')
	{
		return '';
	}
	return asDisplayText(pRecord.StateName) || asDisplayText(pRecord.Status);
}

module.exports = { resolveDocumentStateDisplay, asDisplayText };
